import { render, staticRenderFns } from "./c-footer.vue?vue&type=template&id=2d39b7c5&scoped=true&"
import script from "./c-footer.vue?vue&type=script&lang=js&"
export * from "./c-footer.vue?vue&type=script&lang=js&"
import style0 from "./c-footer.vue?vue&type=style&index=0&id=2d39b7c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d39b7c5",
  null
  
)

export default component.exports